export enum EntityStoreKey {
  JobTemplateTranslations = 'JobTemplateTranslations',
}

export interface JobTemplateTranslationsResponse {
  offerTemplate: JobTemplateTranslations;
}

export interface JobTemplateTranslations {
  id: number;
  description?: string;
  title?: string;
  autoReplyTemplate?: AutoReplyTemplate;
  highlightHtml?: string;
  locationsQuestion?: string;
  requirements?: string;
  sharingDescription?: string;
  sharingTitle?: string;
  openQuestions?: OpenQuestions[];
  error?: string[];
}

export interface OpenQuestions {
  id: number;
  body?: string;
  openQuestionOptions?: OpenQuestionsOptions[];
}

export interface OpenQuestionsOptions {
  id: number;
  body?: string;
}

export interface AutoReplyTemplate {
  id: number;
  subject?: string;
  bodyHtml?: string;
}

export interface TranslateParams {
  jobTemplateId: number;
  targetLanguage: string;
}

export interface JobTemplateTranslationsUpdateRequest {
  langCode: string;
  offerTemplate: JobTemplateTranslations;
}
